import {useMutation} from "react-query";
import {CreateRoleCommand} from "../../models/user";
import roleService from "../../services/RoleService";

export default function useCreateRole() {
   return useMutation((request: CreateRoleCommand) => roleService.create(request));
}